import { Link } from "react-router-dom";
import { Store, ArrowRight } from "lucide-react";

// Shown where appointment/payment screens used to live: everything now runs in the POS register.
export default function PosMovedCard({ what = "Appointments and payments", tab = "schedule", testid = "pos-moved-card" }) {
  return (
    <div className="eyw-card p-6 flex flex-wrap items-center justify-between gap-4 border-l-4 border-l-[#144F75]" data-testid={testid}>
      <div className="flex items-start gap-3">
        <span className="grid place-items-center h-11 w-11 rounded-full bg-[#144F75]/10 shrink-0"><Store size={20} className="text-[#144F75]" /></span>
        <div>
          <p className="font-serif text-lg text-[#1A242B]">{what} now live in the POS register</p>
          <p className="text-sm text-[#4A5D6B]">Search clients, set or reschedule appointments, and take every kind of payment from one screen.</p>
        </div>
      </div>
      <Link to={`/pos?tab=${tab}`} data-testid={`${testid}-open`} className="eyw-btn !py-2.5 text-sm">Open POS <ArrowRight size={15} /></Link>
    </div>
  );
}
